//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/MFGViewMaker.js";
import "../no/Builder.js";
import "../no/ModelingViewList.js";
import "../no/ObjectList.js";
let d=[[[0,"CloneWithTrace",1,0],[1,"SelectedModelViews",0,"ModelingViewList",0],[0,"SourcePart",1,"TaggedObject",0],[0,"TargetPart",1,"TaggedObject",0]],[[["modelViewsNum","viewNames"],"GetModelViewsOfSourcePart",{R_:{modelViews:"ModelingView[]"}},0,0],[["modelView"],"AddModelViewToSelection",{},1,0],[["modelView"],"AddModelViewsToSelection",{},1,0],[[],"ClearSelectedModelViews",{},0,0]],[]];
SPLM.MFGViewMaker.CloneModelViewsBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.MFGViewMaker.CloneModelViewsBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;